import React from 'react';
import { Modal } from 'react-bootstrap';

interface ModalVisualizacaoImgProps {
  getImagemUrl: (index: number) => string;
  imagens?: File[];
  selectedImageIndex: number;
  modalIsOpen?: boolean;
  closeModal: () => void;
}

const ModalVisualizacaoImg: React.FC<ModalVisualizacaoImgProps> = ({ getImagemUrl, selectedImageIndex, modalIsOpen, closeModal }) => {
  const imagemUrl = getImagemUrl(selectedImageIndex);

  return (
    <Modal show={modalIsOpen} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Imagem Ampliada</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {imagemUrl && <img src={imagemUrl} alt={`Imagem ${selectedImageIndex}`} style={{ width: '100%', borderRadius: '4px' }} />}
      </Modal.Body>
    </Modal>
  );
}

export default ModalVisualizacaoImg;
